import { createFileRoute } from "@tanstack/react-router";

// Soi hành trình khách của QC CSKH (QĐ 0521 vòng 4).
export const Route = createFileRoute("/_app/qc-desk/hanh-trinh")({});
